import React, { Fragment } from "react"
import Barcode from "react-barcode"
import clsx from "clsx"

import {
  moment,
  thousandSeparator,
  formatMobilePhone,
  calculateItemSalePrice
} from "utils"
import { paymentTypesLabel, productUnitsSymbol } from "constant"
import classes from "./PlOrderInvoiceTemplateOther.module.scss"

const OptOrderInvoiceTemplate = (props) => {
  const { printData } = props

  const {
    date,
    code,
    dailyOrderNumber,
    items,
    total,
    branch,
    paymentType,
    kitchenTitle,
    isCod,
    subtotal,
    totalDiscount,
    deliveryFee,
    address,
    customerFullName,
    customerMobilePhone
  } = printData

  return (
    <div className={clsx(classes["content"], classes["factor"])}>
      <div className={classes["header"]}>
        <div className={classes["logo"]}><img alt="" /></div>
        <div className={classes["text"]}>فاکتور</div>
        <div className={classes["info"]}>
          <p>شماره فاکتور: {code}</p>
          {dailyOrderNumber !== undefined &&
            <p>شماره سفارش: {String(dailyOrderNumber).padStart(3, "0")}</p>
          }
          <Barcode
            height={20}
            displayValue={false}
            value={`${code}`}
          />
          <p>تاریخ: {moment(date).format("jYYYY/jMM/jDD")}</p>
        </div>
      </div>
      <table>
        <tr>
          <th width="50%">فروشنده</th>
          <th width="50%">خریدار</th>
        </tr>
        <tr>
          <td>
            <p>
              <b style={{ paddingLeft: "32px" }}>
                فروشنده: {kitchenTitle}
              </b>

              <br />

              <b>تلفن: {branch?.contactNumber}</b>{" "}

              <br />

              <b>نشانی: {branch?.address}</b>
            </p>
          </td>

          <td>
            <p>
              <b>خریدار: </b> {customerFullName}

              {
                !!address &&
                <Fragment>
                  <br />
                  <b>استان: </b>{" "}
                  {address.state}{" "}
                  <b>شهر: </b>{" "}
                  {address.city}{" "}
                  <b>کد پستی: </b>{" "}
                  {address.zipCode}{" "}
                </Fragment>
              }

              <br />

              <b>شماره تماس: </b>{" "}
              {formatMobilePhone(
                address?.recipientPhoneNumber ||
                customerMobilePhone
              )}

              <br />

              {
                !!address &&
                <Fragment>
                  <b>نشانی: </b>
                  {address.address}
                </Fragment>
              }
            </p>
          </td>
        </tr>
      </table>
      <table>
        <tr>
          <th>ردیف</th>
          <th>کد کالا</th>
          <th className={classes["image-col"]}>تصویر</th>
          <th style={{ width: "50%" }}>شرح کالا یا خدمات</th>
          <th>واحد</th>
          <th>مبلغ واحد<br />(تومان)</th>
          <th>مبلغ کل<br />(تومان)</th>
        </tr>

        {items.map((item, itemIndex) =>
          <tr key={itemIndex}>
            <td className={classes["centerp"]}>
              {itemIndex + 1}
            </td>
            <td className={classes["centerp"]}>
              {item.optionBarCode || item.sku || item.foodCode}
            </td>
            <td className={classes["centerp"]}>
              <img
                src={`${item.foodImageCover}?width=100&quality=60`}
                className={classes["attachment-50x50"]}
                decoding="async"
                alt=""
              />
            </td>
            <td>
              {item.foodName}{!item.isSimple ? ` - ${item.optionName}` : ""}
            </td>
            <td className={classes["centerp"]}>
              {item.quantity}{productUnitsSymbol[item.unit]}
            </td>
            <td className={classes["centerp"]}>
              {thousandSeparator(
                calculateItemSalePrice(item),
                ""
              )}
            </td>
            <td className={classes["centerp"]}>
              {thousandSeparator(
                calculateItemSalePrice(item) * item.quantity,
                ""
              )}
            </td>
          </tr>
        )}

        <tr>
          <td colSpan="5" className={classes["leftp"]}>مجموع:</td>
          <td colSpan="2" className={classes["centerp"]}>
            {thousandSeparator(subtotal)}
          </td>
        </tr>


        {
          !!address &&
          <tr>
            <td colSpan="5" className={classes["leftp"]}>حمل و نقل:</td>
            <td colSpan="2" className={classes["centerp"]}>
              {thousandSeparator(deliveryFee)}
            </td>
          </tr>
        }

        <tr>
          <td colSpan="5" className={classes["leftp"]}>روش پرداخت:</td>
          <td colSpan="2" className={classes["centerp"]}>
            {isCod ? "نقدی" : paymentTypesLabel[paymentType]}
          </td>
        </tr>

        <tr>
          <td colSpan="5" className={classes["leftp"]}>تخفیف:</td>
          <td colSpan="2" className={classes["centerp"]}>
            {thousandSeparator(-totalDiscount)}
          </td>
        </tr>

        <tr>
          <th colSpan="5" className={classes["leftp"]}>قیمت نهایی:</th>
          <th colSpan="2" className={classes["centerp"]}>
            {thousandSeparator(total)}
          </th>
        </tr>
      </table>
    </div >
  )
}

export default OptOrderInvoiceTemplate
